import React from "react";

function inputStyle() {
  return {
    width: "100%",
    minHeight: 40,
    padding: "0 11px",
    borderRadius: 11,
    color: "#0f172a",
    background: "#ffffff",
    border: "1px solid #cbd5e1",
    boxSizing: "border-box",
    fontSize: 12,
    fontWeight: 700,
  };
}

function labelStyle() {
  return {
    marginBottom: 5,
    color: "#475569",
    fontSize: 10,
    fontWeight: 900,
    textTransform: "uppercase",
  };
}

function ContactSection({
  title,
  description,
  contact = {},
  onChange,
}) {
  return (
    <div
      style={{
        padding: 14,
        borderRadius: 16,
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
      }}
    >
      <div
        style={{
          color: "#0f172a",
          fontSize: 14,
          fontWeight: 950,
        }}
      >
        {title}
      </div>

      {description ? (
        <div
          style={{
            marginTop: 3,
            marginBottom: 11,
            color: "#64748b",
            fontSize: 10,
            fontWeight: 700,
          }}
        >
          {description}
        </div>
      ) : null}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(2, minmax(0, 1fr))",
          gap: 10,
        }}
      >
        <div>
          <div style={labelStyle()}>Name</div>
          <input
            value={contact?.name || ""}
            placeholder="Contact name"
            style={inputStyle()}
            onChange={(event) =>
              onChange("name", event.target.value)
            }
          />
        </div>

        <div>
          <div style={labelStyle()}>Title</div>
          <input
            value={contact?.title || ""}
            placeholder="Position or title"
            style={inputStyle()}
            onChange={(event) =>
              onChange("title", event.target.value)
            }
          />
        </div>

        <div>
          <div style={labelStyle()}>Phone</div>
          <input
            type="tel"
            value={contact?.phone || ""}
            placeholder="Phone number"
            style={inputStyle()}
            onChange={(event) =>
              onChange("phone", event.target.value)
            }
          />
        </div>

        <div>
          <div style={labelStyle()}>Email</div>
          <input
            type="email"
            value={contact?.email || ""}
            placeholder="Email address"
            style={inputStyle()}
            onChange={(event) =>
              onChange("email", event.target.value)
            }
          />
        </div>
      </div>
    </div>
  );
}

export default function Facility360Contacts({
  facility,
  onChangeFacility,
}) {
  function updateContact(
    contactKey,
    field,
    value
  ) {
    if (
      typeof onChangeFacility !== "function"
    ) {
      return;
    }

    onChangeFacility((previousFacility) => ({
      ...previousFacility,
      [contactKey]: {
        ...(previousFacility?.[contactKey] ||
          {}),
        [field]: value,
      },
    }));
  }

  const primaryContact = {
    name:
      facility?.primaryContact?.name ||
      facility?.contactName ||
      "",
    title:
      facility?.primaryContact?.title ||
      facility?.contactTitle ||
      "",
    phone:
      facility?.primaryContact?.phone ||
      facility?.phone ||
      "",
    email:
      facility?.primaryContact?.email ||
      facility?.email ||
      "",
  };

  const billingContact =
    facility?.billingContact || {};

  const schedulingContact =
    facility?.schedulingContact || {};

  const afterHoursContact =
    facility?.afterHoursContact || {};

  return (
    <div style={{ display: "grid", gap: 14 }}>
      <div>
        <div
          style={{
            color: "#0f172a",
            fontSize: 20,
            fontWeight: 950,
          }}
        >
          Facility Contacts
        </div>

        <div
          style={{
            marginTop: 4,
            color: "#64748b",
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          Operational, scheduling, billing, and emergency contacts for{" "}
          {facility?.name ||
            facility?.facilityName ||
            facility?.id ||
            "this facility"}
          .
        </div>

        <div
          style={{
            marginTop: 5,
            color: "#7c3aed",
            fontSize: 10,
            fontWeight: 800,
          }}
        >
          Contact changes are saved when you select Save.
        </div>
      </div>

      <ContactSection
        title="Primary Contact"
        description="Main administrator or client representative."
        contact={primaryContact}
        onChange={(field, value) =>
          updateContact(
            "primaryContact",
            field,
            value
          )
        }
      />

      <ContactSection
        title="Scheduling Contact"
        description="Person responsible for staffing requests and schedule coordination."
        contact={schedulingContact}
        onChange={(field, value) =>
          updateContact(
            "schedulingContact",
            field,
            value
          )
        }
      />

      <ContactSection
        title="Billing Contact"
        description="Person responsible for invoices, statements, and payment questions."
        contact={billingContact}
        onChange={(field, value) =>
          updateContact(
            "billingContact",
            field,
            value
          )
        }
      />

      <ContactSection
        title="After-Hours Contact"
        description="Emergency or after-hours operational contact."
        contact={afterHoursContact}
        onChange={(field, value) =>
          updateContact(
            "afterHoursContact",
            field,
            value
          )
        }
      />

      <div
        style={{
          padding: 14,
          borderRadius: 16,
          background: "#f8fafc",
          border: "1px solid #e2e8f0",
        }}
      >
        <div style={labelStyle()}>
          Contact Notes
        </div>

        <textarea
          value={facility?.contactNotes || ""}
          placeholder="Add facility contact instructions or notes..."
          rows={4}
          onChange={(event) => {
            if (
              typeof onChangeFacility !==
              "function"
            ) {
              return;
            }

            onChangeFacility(
              (previousFacility) => ({
                ...previousFacility,
                contactNotes:
                  event.target.value,
              })
            );
          }}
          style={{
            ...inputStyle(),
            minHeight: 96,
            padding: 11,
            resize: "vertical",
            fontFamily: "inherit",
          }}
        />
      </div>
    </div>
  );
}